/* eslint-disable jsx-a11y/href-no-hash */
import React, { Component } from 'react';
import { Table, Button } from 'semantic-ui-react';

import './DashboardList.css';

class DashboardList extends Component {
  state = {
    showConfirm: false
  };

  openDialog = (e, { data }) => {
    this.setState({ showConfirm: true, deleteRowId: data.id });
  };

  handleCancel = () => {
    this.setState({ showConfirm: false });
  };

  deleteDashboard = () => {
    this.props.deleteDashboard(this.state.deleteRowId);
    this.setState({ showConfirm: false });
  };

  editDashboard = (e, { data }) => {
    this.props.editDashboard(data.id);
  };

  generateTagCells = (dashboardId, category) => {
    const { dashboardsTags } = this.props;

    const matchedTagRows = dashboardsTags.filter((row) => {
      return row[0].dashboard_id === dashboardId;
    });

    let value = ' ';

    matchedTagRows.forEach((row) => {
      for (let i = 0; i < row.length; i += 1) {
        if (row[i].tag.category === category) {
          value = row[i].tag.value;
        }
      }
    });

    return value;
  };

  render() {
    const { dashboards, newDashboard, tagCategories } = this.props;
    const { showConfirm, deleteRowId } = this.state;

    if (dashboards) {
      return (
        <div>
          <div className='new-dashboard-link'>
            <a href='#' onClick={newDashboard}>
              NEW DASHBOARD +
            </a>
          </div>
          <Table sortable celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>Dashboard ID</Table.HeaderCell>
                <Table.HeaderCell>Alias</Table.HeaderCell>
                <Table.HeaderCell>Internal Description</Table.HeaderCell>
                <Table.HeaderCell>External Description</Table.HeaderCell>
                {tagCategories.map((category) => {
                  return <Table.HeaderCell>{category}</Table.HeaderCell>;
                })}
                <Table.HeaderCell className='dashboard-row-operations'>
                  Operations
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {dashboards.map((item) => (
                <Table.Row key={item.id}>
                  <Table.Cell>{item.name}</Table.Cell>

                  <Table.Cell>{item.dashboard_id}</Table.Cell>
                  <Table.Cell>{item.alias}</Table.Cell>
                  <Table.Cell>{item.internal_desc}</Table.Cell>
                  <Table.Cell>{item.external_desc}</Table.Cell>
                  {tagCategories.map((category) => {
                    return (
                      <Table.Cell>
                        {this.generateTagCells(item.id, category)}
                      </Table.Cell>
                    );
                  })}
                  <Table.Cell className='dashboard-operations-buttons'>
                    {showConfirm && item.id === deleteRowId ? (
                      <div className='dashboard-div-confirm'>
                        <p className='text-confirm'>Are you sure?</p>
                        <Button
                          onClick={this.deleteDashboard}
                          size='mini'
                          color='grey'
                        >
                          Yes
                        </Button>
                        <Button
                          onClick={this.handleCancel}
                          size='mini'
                          color='red'
                        >
                          No
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          data={{ id: item.id }}
                          onClick={this.editDashboard}
                          size='small'
                          color='teal'
                        >
                          Edit
                        </Button>
                        <Button
                          data={{ id: item.id }}
                          onClick={this.openDialog}
                          size='small'
                          color='red'
                        >
                          Delete
                        </Button>
                      </div>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      );
    }
    return null;
  }
}

export default DashboardList;



// WEBPACK FOOTER //
// ./src/screens/LookerDashboard/DashboardList.js